module.exports = __webpack_public_path__ + "img/mortar_pin_red.7e35c033.svg";